import React from "react";
import DocumentViewer from "../../Common/DocumentViewer/DocumentViewer";

const PrivacyPolicy: React.FC = () => {
    const docUrl = "/evonext.ai/RegPulse-Privacy-Policy-v2.docx"
  

//   return (
//     <div style={{ padding: "24px" }}>
//       <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit"  }}>
//         {content}
//       </pre>
//     </div>
//   );
 return (
  <>
    <div style={{padding:"60px" }}>
      {/* <h1>Document</h1> */}
      <DocumentViewer docUrl={docUrl} />
    </div>
    </>
  );
};

export default PrivacyPolicy;